/* Geteilte, seitenweite Versand-Schwellen-Umschaltung (Entscheid Andreas
   28.07.2026). Wird von zwei unabhaengigen Quellen aufgerufen:
   1. Diese Datei selbst, bei einem echten Shopify-Variantenwechsel
      (PUB_SUB_EVENTS.variantChange).
   2. jk-quantity-breaks.js, bei einer Mengen-Kacheln-Auswahl (kein
      Variantenwechsel, nur ein Mengen-Multiplikator auf derselben
      Variante — feuert nie variantChange).
   Beide jk_trust_points (jk-main-product) UND jk-guarantee-closer
   rendern [data-jk-ship-toggle] nach demselben Markup-Muster; ein
   seitenweiter Selektor haelt beide synchron, ohne dass die Sections
   sich gegenseitig kennen muessen. Als globale Function-Deklaration
   (kein IIFE-Scope) bewusst gewaehlt, damit andere <script defer>-
   Dateien sie unabhaengig von der Ladereihenfolge aufrufen koennen —
   wird ausschliesslich aus Event-Handlern (nie synchron beim initialen
   Parsen) aufgerufen, daher keine Race Condition mit der Skript-
   Ladereihenfolge. */
function jkUpdateShippingToggles(priceCents) {
  if (typeof priceCents !== 'number' || Number.isNaN(priceCents)) return;
  document.querySelectorAll('[data-jk-ship-toggle]').forEach((el) => {
    const threshold = parseInt(el.dataset.threshold, 10) || 6000;
    const reached = priceCents >= threshold;
    const full = el.querySelector('[data-jk-ship-full]');
    const min = el.querySelector('[data-jk-ship-min]');
    if (full) full.hidden = !reached;
    if (min) min.hidden = reached;
  });
}

if (!customElements.get('jk-delivery-promise')) {
  customElements.define(
    'jk-delivery-promise',
    class JkDeliveryPromise extends HTMLElement {
      connectedCallback() {
        this._unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this._onVariantChange.bind(this));
        this._updateCutoffText();
      }

      disconnectedCallback() {
        if (this._unsubscribe) this._unsubscribe();
      }

      _getStatus(variant) {
        if (!variant) return 'out-of-stock';

        if (!variant.available) {
          return variant.inventory_policy === 'continue' ? 'preorder' : 'out-of-stock';
        }

        if (variant.inventory_management === 'shopify') {
          const threshold = parseInt(this.dataset.threshold, 10) || 5;
          if (variant.inventory_quantity <= threshold) return 'low-stock';
        }

        return 'in-stock';
      }

      _deliveryRowsEl() {
        return this.parentElement?.querySelector(
          `[data-jk-delivery-rows][data-section="${this.dataset.section}"]`
        );
      }

      _isBeforeCutoff(cutoffTime, timezone) {
        try {
          const now   = new Date();
          const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: timezone,
            weekday:  'short',
            hour:     'numeric',
            minute:   'numeric',
            hour12:   false,
          }).formatToParts(now);
          const get     = (type) => parts.find((p) => p.type === type)?.value ?? '';
          const weekday = get('weekday');
          const hour    = parseInt(get('hour'),   10);
          const minute  = parseInt(get('minute'), 10);
          const [cutH, cutM] = cutoffTime.split(':').map(Number);
          const isWeekday  = weekday !== 'Sat' && weekday !== 'Sun';
          const beforeTime = hour < cutH || (hour === cutH && minute < cutM);
          return isWeekday && beforeTime;
        } catch (_) {
          return false;
        }
      }

      _updateCutoffText() {
        const rows = this._deliveryRowsEl();
        if (!rows) return;
        const textEl = rows.querySelector('[data-jk-cutoff-text]');
        if (!textEl) return;
        const before     = rows.dataset.beforeCutoff;
        const after      = rows.dataset.afterCutoff;
        const cutoffTime = rows.dataset.cutoffTime || '11:00';
        const timezone   = rows.dataset.timezone   || 'Europe/Zurich';
        textEl.textContent = this._isBeforeCutoff(cutoffTime, timezone) ? before : after;
      }

      _onVariantChange({ data: { sectionId, variant } }) {
        if (sectionId !== this.dataset.section) return;

        const status = this._getStatus(variant);

        const texts = {
          'in-stock':     this.dataset.inStockText,
          'low-stock':    this.dataset.lowStockText,
          'out-of-stock': this.dataset.outOfStockText,
          'preorder':     this.dataset.preorderText,
        };

        ['in-stock', 'low-stock', 'out-of-stock', 'preorder'].forEach((s) => {
          this.classList.toggle(`jk-delivery-promise--${s}`, s === status);
        });

        const textEl = this.querySelector('.jk-delivery-promise__text');
        if (textEl) textEl.textContent = texts[status] || '';

        const rows = this._deliveryRowsEl();
        if (rows) {
          rows.hidden = status !== 'in-stock' && status !== 'low-stock';
        }

        this._notifyShippingThreshold(variant);
      }

      /* Versand-Trust-Text: Varianten koennen die Gratisversand-Schwelle
         kreuzen. Beide Textvarianten liegen im Markup ([data-jk-ship-full]
         / [data-jk-ship-min]); hier wird anhand des Variantenpreises
         umgeschaltet. Ohne JS bleibt der serverseitige Initialzustand.
         Falls auf derselben Section auch Mengen-Kacheln (jk-quantity-
         breaks) aktiv sind, zaehlt deren aktuell gewaehlte Menge x
         Rabatt mit (Entscheid Andreas 28.07.2026) — sonst wuerde ein
         echter Variantenwechsel die Mengen-Auswahl fuer die Schwellen-
         Pruefung stillschweigend zuruecksetzen. */
      _notifyShippingThreshold(variant) {
        if (!variant || typeof variant.price !== 'number') return;
        let price = variant.price;
        const qtyBreaks = document.querySelector(
          `jk-quantity-breaks[data-section-id="${this.dataset.section}"]`
        );
        const checkedTile = qtyBreaks?.querySelector('input[type="radio"]:checked');
        if (checkedTile) {
          const qty      = parseInt(checkedTile.dataset.qty, 10) || 1;
          const discount = parseInt(checkedTile.dataset.discount, 10) || 0;
          price = Math.round(variant.price * qty * (100 - discount) / 100);
        }
        jkUpdateShippingToggles(price);
      }
    }
  );
}
